const Folders = {
  OPEN: 'open',
  DONE: 'done',
  SPAM: 'spam',
};

export default Folders;
